<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { useI18n } from 'vue-i18n';
import LaisStatusBadge from 'dashboard/components-next/LaisStatusBadge.vue';
import LaisChecklistPanel from 'dashboard/components-next/LaisChecklistPanel.vue';

defineProps({
  summary: {
    type: Object,
    default: () => ({}),
  },
  items: {
    type: Array,
    default: () => [],
  },
  explicitBlockers: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['action']);

const { t } = useI18n();
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <div class="grid gap-3">
    <div
      class="flex items-start justify-between gap-3 rounded-lais border border-lais-border-soft bg-white px-4 py-3 shadow-lais-card"
    >
      <div class="min-w-0">
        <p
          class="font-redHatDisplay text-[16px] font-semibold leading-tight text-lais-text"
        >
          {{ t('PROPERTIES.READINESS.TITLE') }}
        </p>
        <p class="mt-1 text-[12px] leading-relaxed text-lais-text-muted">
          {{ t('PROPERTIES.READINESS.HELPER') }}
        </p>
      </div>
      <LaisStatusBadge :label="summary.label" :tone="summary.tone" dot />
    </div>
    <LaisChecklistPanel
      :items="items"
      :title="t('PROPERTIES.READINESS.CHECKLIST_TITLE')"
      :empty-label="t('PROPERTIES.READINESS.EMPTY')"
      @action="emit('action', $event)"
    />
    <div
      v-if="explicitBlockers.length"
      class="rounded-lais border border-lais-danger/40 bg-lais-danger-50 px-4 py-3 text-[12px] leading-relaxed text-lais-danger"
    >
      <p class="font-semibold">
        {{ t('PROPERTIES.READINESS.EXPLICIT_BLOCKERS') }}
      </p>
      <ul class="mt-2 list-disc space-y-1 pl-4">
        <li v-for="blocker in explicitBlockers" :key="blocker.key">
          {{ blocker.label }}
        </li>
      </ul>
    </div>
  </div>
</template>
